import taxonomyAPIFactory from "../taxonomy/api"

const api = taxonomyAPIFactory({ taxonomyId: 'disease' })

export default api